var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pop-up"},[_c('p',{staticClass:"pop-up__content mb-20"},[_vm._v(_vm._s(_vm.content))]),_c('button',{staticClass:"pop-up__close button",on:{"click":_vm.togglePopup}},[_vm._v(_vm._s(_vm.$t('auth.ok')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }